// 获取随机uuid
export function getRandomId (prefix) {
  var d = new Date().getTime();
  if (window.performance && typeof window.performance.now === 'function') {
    d += performance.now(); // use high-precision timer if available
  }
  var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (d + Math.random() * 16) % 16 | 0; // d是随机种子
    d = Math.floor(d / 16);
    return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
  });
  return prefix ? `${prefix}-${uuid}` : uuid;
}

// 获取窗口可是范围的高度
export function getClientHeight () {
  let clientHeight = 0;
  if (document.body.clientHeight && document.documentElement.clientHeight) {
    clientHeight =
      document.body.clientHeight < document.documentElement.clientHeight
        ? document.body.clientHeight
        : document.documentElement.clientHeight;
  } else {
    clientHeight =
      document.body.clientHeight > document.documentElement.clientHeight
        ? document.body.clientHeight
        : document.documentElement.clientHeight;
  }
  return clientHeight;
}

function requestAnimationFrameAnimate (el, className) {
  console.log('className: ', className);
  if (el.classList.contains(className)) {
    el.classList.remove(className)
    // 下一帧 添加类名
    requestAnimationFrame(() => {
      console.log('requestAnimationFrame')
      el.classList.add(className)
    })
  } else {
    // 下一帧 添加类名
    requestAnimationFrame(() => {
      console.log('requestAnimationFrame')
      el.classList.add(className)
    })
  }
}

/**
 * 
 * @param {element} el 
 * @param {({
 * className: string
 * })} options 
 * options.className: 抖动 'shock-show' | 左右抖动 'shock-left-right'
 */
export const shock = function (el, options) {
  const className = options && options.className || 'shock-show'
  requestAnimationFrameAnimate(el, className)
}

/**
 * 
 * @param {object} options
 * @param {number} options.x 
 * @returns 
 */
export function getElementsFromPoint ({ x, y }) {
  if (document.elementsFromPoint) {
    return document.elementsFromPoint(x, y);
  } else {
    // 如果浏览器不支持 elementsFromPoint 方法，则使用辅助方法获取元素
    var elements = [];
    var originalElement = document.elementFromPoint(x, y);

    // 递归遍历所有父元素以获取位于指定位置的所有元素
    while (originalElement) {
      elements.push(originalElement);
      originalElement.style.pointerEvents = 'none'; // 禁用当前元素的点击事件

      var newElement = document.elementFromPoint(x, y);
      if (newElement === originalElement) break;

      originalElement = newElement;
    }

    // 恢复被禁用的元素的点击事件
    elements.forEach(function (element) {
      element.style.pointerEvents = 'auto';
    });

    return sortElementsByDocumentOrder(elements);
  }
}